import React, { Component } from 'react';
import Header from '@/Header';
import Main from '@/Main';

export default class Panel extends Component {
  render() {
    return (
      <div className="billy-panel billy-dir_rtl">
        <div className="billy-panel-header">
          <Header />
        </div>
        <div className="billy-panel-main">
          <div className="billy-panel-main__wrapper">
            <Main />
          </div>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Panel/index.js